import Link from 'launch/components/Link';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const PrivacyLink = () => (
    <Link href="/legal/privacy" target="_blank" variations={['default']}>
        <FormattedMessage id="privacy" />
    </Link>
);

export default PrivacyLink;



// WEBPACK FOOTER //
// ./js/launch/components/PrivacyLink.jsx